<template>
  <div
    style="padding: 10px 10px 10px 0; page-break-before: auto; page-break-after: always"
  >
    <el-dialog
      :visible.sync="show"
      width="700px"
      id="printTest"
      :before-close="handleClose"
    >
      <div ref="print" style="margin-top: 0px; padding: 0">
        <div
          style="
            border-top: 1px solid #000000;
            border-bottom: 1px solid #000000;
            text-align: center;
            font-size: 24px;
            padding: 2px 0;
          "
        >
          缴款通知书
        </div>
        <div>商品名称: {{ obj.shopName }}</div>
        <div>经营品牌: {{ obj.shopName }}</div>
        <div
          style="
            display: flex;
            justify-content: space-between;
            border-bottom: 1px solid #000000;
          "
        >
          <div>商铺编号: {{ obj.shopNum }}</div>
          <div>合同号: {{ obj.number }}</div>
        </div>
        <div>尊敬的供应商:</div>
        <div style="margin: 2px 0">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;根据贵我双方租赁合同中的有关条款约定，请贵司按期将下列款项汇至本公司账户。
        </div>
        <div>户名: 江苏国际人才咨询服务有限公司</div>
        <div style="margin: 2px 0">开 户 银 行: 中国银行江苏省分行营业部</div>
        <div>账号: 5092 6897 8348</div>
        <div
          style="
            margin: 0px 0 0 30px;
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
        >
          <div>谢谢合作!</div>
          <el-button v-if="isAdd&&(obj.status != '已缴费'&&obj.wuyeStatus != '1'&&obj.promotionStatus != '1')" type="primary" size="mini" @click="addShopPay()"
            >新增</el-button
          >
        </div>
        <el-table :data="bdShopPayList" style="width: 100%" border :key="comKey">
          <el-table-column prop="type" label="款项类别" width="100"></el-table-column>
          <el-table-column prop="timeQuantum" label="账期时间">
            <template slot-scope="scope">
              <!-- <el-input v-model=" scope.row.timeQuantum" placeholder="请输入时间" v-if="scope.row.type == '其他' && scope.row.editIs == '1'" size="small" ></el-input>  -->
              <span>{{ scope.row.timeQuantum ? scope.row.timeQuantum : "" }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="endTime" label="最后缴款日"> </el-table-column>
          <el-table-column prop="money" label="应交金额(元)">
            <template slot-scope="scope">
              <span v-if="scope.row.editIs == '0'">
                {{ scope.row.amount }}
              </span>
              <el-input
                v-else
                v-model="scope.row.amount"
                placeholder="请输入金额"
              ></el-input>
            </template>
          </el-table-column>

          <el-table-column prop="remark" label="备注">
            <template slot-scope="scope">
              <span v-if="scope.row.editIs == '0'">
                {{ scope.row.remark }}
              </span>
              <el-input
                v-else
                v-model="scope.row.remark"
                placeholder="请输入备注"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column v-if="isDyxs" class="no-print" width="80" label="操作">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.editIs == '0' && scope.row.editNo != '-1'"
                type="primary"
                size="mini"
                @click="editShopPay(scope.row, scope.$index)"
                >修改</el-button
              >
              <el-button
                v-if="scope.row.editIs == '1'"
                type="primary"
                size="mini"
                @click="saveShopPay(scope.row, scope.$index)"
                >保存</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <!-- 	<div style="margin: 0 0 5px 10px;">备注:提成租金:第1年5%扣点。</div> -->
        <!-- <div style="margin: 0 0 0 15px;">电费:1元/度: 水费:按公共事业公布标准+10%的管理费</div> -->

        <!-- <div style="margin: 10px 0 0 15px;color: red;" v-if="obj.balance < 0">欠费：{{ obj.balance }}元</div> -->
        <div style="margin: 10px 0 0 15px">合计：{{ parseFloat(sum).toFixed(2) }}元</div>

        <!-- <div
          v-if="isDyxs && obj.balance > 0"
          style="margin: 10px 0 0 15px; color: #30c25b"
        >
          账户余额：{{ parseFloat(obj.balance).toFixed(2) }}元
        </div> -->
        <div style="text-align: right; margin-top: 50px">
          江苏国际人才咨询服务有限公司
        </div>
        <div style="text-align: right">
          {{ new Date().getFullYear() }}年{{ new Date().getMonth() + 1 }} 月{{
            new Date().getDate()
          }}日
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="
            show = false;
            isDyxs = true;
          "
          >关 闭</el-button
        >
        <el-button plain @click="aaa" type="primary">打 印</el-button>
      </span>
    </el-dialog>

    <el-dialog title="修改" :visible.sync="isChange" width="30%">
      <el-form :model="form">
        <el-form-item label="租金状态">
          <el-select v-model="status" placeholder="状态" style="width: 100px">
            <el-option label="已缴费" value="已缴费"></el-option>
            <el-option label="未缴费" value="未缴费"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isChange = false">关 闭</el-button>
        <el-button @click="isOk" type="primary">确 定</el-button>
      </span>
    </el-dialog>
    <el-form :inline="true" :model="form" class="demo-form-inline">
      <div class="flex sb">
        <div>
          <el-form-item label="商铺号">
            <!-- <el-input size="small" v-model="form.shopNum" placeholder="商铺号" style="width: 150px;"
                            clearable></el-input> -->
            <el-select
              filterable
              size="small"
              v-model="form.shopNum"
              placeholder="请选择商铺号"
              clearable
              style="width: 150px"
            >
              <el-option
                v-for="item in shopList"
                :label="item.shopNum"
                :value="item.shopNum"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="商铺名称">
            <!-- <el-input size="small" v-model="form.shopName" placeholder="商铺名称" style="width: 150px;"
                            clearable></el-input> -->
            <el-select
              filterable
              size="small"
              v-model="form.shopName"
              placeholder="请选择商铺名称"
              clearable
              style="width: 240px"
            >
              <el-option
                v-for="item in shopList"
                :label="item.brandName"
                :value="item.brandName"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="出账年月">
            <el-date-picker
              size="small"
              type="monthrange"
              value-format="yyyy-MM"
              range-separator="至"
              start-placeholder="开始年月"
              end-placeholder="结束年月"
              v-model="queryDate"
              style="width: 100%"
            ></el-date-picker>
          </el-form-item>

          <!-- <el-form-item label="租金状态">
                            <el-select clearable v-model="form.status" placeholder="状态" style="width: 100px;">
                                <el-option label="已缴费" value="已缴费"></el-option>
                                <el-option label="未缴费" value="未缴费"></el-option>
                            </el-select>
                        </el-form-item> -->
          <el-form-item label="是否已对账">
            <el-select
              size="small"
              v-model="form.payOrNot"
              placeholder="是否已对账"
              clearable
              style="width: 150px"
            >
              <el-option label="已对账" value="已对账"></el-option>
              <el-option label="未对账" value="未对账"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="query">查询</el-button>
          </el-form-item>
          <!-- <el-form-item>
                        <el-button size="small" type="primary" @click="dcAll">下载缴款通知书</el-button>
                    </el-form-item> -->
          <el-form-item>
            <el-button type="primary" size="small" @click="dc">导出</el-button>
          </el-form-item>

          <el-form-item>
            <span>总合计:{{ pageSum }}</span>
          </el-form-item>
          <el-form-item>
            <span>租金合计:{{ zujinsum }}</span>
          </el-form-item>
          <el-form-item>
            <span>物业费合计:{{ wuyesum }}</span>
          </el-form-item>
          <el-form-item>
            <span>推广费合计:{{ tuiguangsum }}</span>
          </el-form-item>
          <el-form-item>
            <span>其他合计:{{ qitasum }}</span>
          </el-form-item>
        </div>
      </div>
    </el-form>
    <el-table
      :data="data"
      style="width: 100%"
      v-loading="loading"
      @selection-change="handleSelectionChange"
    >
      <!-- <el-table-column type="selection" width="55">
            </el-table-column> -->
      <el-table-column label="商铺号" prop="shopNum" align="center"> </el-table-column>
      <el-table-column label="商铺名称" prop="shopName" align="center"> </el-table-column>
      <el-table-column label="账期时间" prop="appdate" align="center" width="200">
        <template slot-scope="{ row }">
          <span>{{ row.paymentDay }}</span>
        </template>
      </el-table-column>
      <el-table-column label="租金" prop="money" align="center">
        <template slot-scope="{ row }">
          <div v-if="row.status == '已缴费'">
            <span :style="'color:#30C25B'"> {{ parseFloat(row.money).toFixed(2) }}</span>
          </div>
          <div v-else-if="row.comment" style="color: #101dfa">
            {{ parseFloat(row.money).toFixed(2) }}
          </div>
          <div v-else>
            <span :style="'color:red'"> {{ parseFloat(row.money).toFixed(2) }}</span>
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="status" label="缴费状态">
                    <template slot-scope="{row}">
                        <span :style="row.status == '已缴费' ? 'color:#30C25B' : 'color:red'">
                            {{ row.status == '已缴费' ? '已缴费' : '未缴费' }}</span>
                    </template>
                </el-table-column> -->
      <el-table-column label="物业费" prop="wuyepay" align="center">
        <template slot-scope="{ row }">
          <div v-if="row.wuyeStatus == '1'">
            <span :style="'color:#30C25B'"> {{ row.wuyepay }}</span>
          </div>
          <div v-else-if="row.remarkWy" style="color: #101dfa">
            {{ row.wuyepay }}
          </div>

          <div v-else>
            <span :style="'color:red'"> {{ row.wuyepay }}</span>
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="status" label="缴费状态">
                    <template slot-scope="{row}">
                        <span :style="row.wuyeStatus == '1' ? 'color:#30C25B' : 'color:red'">
                            {{ row.wuyeStatus == '1' ? '已缴费' : '未缴费' }}</span>
                    </template>
                </el-table-column> -->
      <el-table-column label="推广费" prop="promotionSum" align="center">
        <template slot-scope="{ row }">
          <div v-if="row.promotionStatus == '1'">
            <span :style="'color:#30C25B'"> {{ row.promotionSum }}</span>
          </div>
          <div v-else-if="row.remarkTg" style="color: #101dfa">
            {{ row.promotionSum }}
          </div>

          <div v-else>
            <span :style="row.promotionStatus == '1' ? 'color:#30C25B' : 'color:red'">
              {{ row.promotionSum }}</span
            >
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="date" label="操作">
        <template slot-scope="{ row }">
          <el-button type="text" @click="lookRow(row)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      v-if="count > 0"
      :page-sizes="[10, 20, 30, 50]"
      :page-size="form.pageSize"
      :current-page.sync="form.currentPage"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      layout="total, sizes, prev, pager, next, jumper"
      :total="count"
    >
    </el-pagination>
  </div>
</template>

<script>
import publicExport from "../../../assets/js/publicExport.js";
import downloadFile from "../../../assets/js/downloadFile.js";
import { setTimeout } from "timers";
export default {
  data() {
    return {
      rowTome: "",
      isAdd: true,
      comKey: true,
      queryDate: [],
      loading: false,
      sum: 0,
      count: 0,
      isDyxs: true,
      users: [], //申请人
      show: false,
      status: "",
      id: "",
      bdShopPayList: [],
      timeOther: [],
      form: {
        payOrNot: "",
        startDate: "", //申请人id
        endDate: "", //联系电话
        result: "", //状态
        shopName: "", //商铺名称
        shopNum: "", //商铺号
        type: "", //类型（正常，违规）
        currentPage: 1,
        pageSize: 10,
      },
      addForm: {},
      data: [],
      obj: {
        fileRes: "",
        applyTime: "",
      }, //详情数据
      isChange: false,
      show2: false, //控制筛选列的多选框
      oneRow: "", //当checkList列表只有一项时,选择框不可点击
      checkList: [
        "商铺号",
        "商铺名称",
        "联系人",
        "联系方式",
        "账期时间",
        "租金",
        "租金增值税9%",
        "租金收入",
        "物业费",
        "物业增值税6%",
        "物业费收入",
        "推广费",
        "推广增值税6%",
        "推广费收入",
        "购电费",
        "水费",
        "应缴合计",
      ],
      titleObj: {
        shopNum: "商铺号",
        shopName: "商铺名称",
        name: "联系人",
        phone: "联系方式",
        appdate: "账期时间",
        money: "租金",
        rentalRevenue: "租金增值税9%",
        rentalIncome: "租金收入",
        wuyepay: "物业费",
        wuyeRevenue: "物业增值税6%",
        wuyeIncome: "物业费收入",
        promotionSum: "推广费",
        promotionRevenue: "推广增值税6%",
        promotionIncome: "推广费收入",
        electricPay: "购电费",
        waterPay: "水费",
        total: "应缴合计",
      },
      oldTitleObj: {
        shopNum: "商铺号",
        shopName: "商铺名称",
        name: "联系人",
        phone: "联系方式",
        appdate: "账期时间",
        money: "租金",
        rentalRevenue: "租金增值税9%",
        rentalIncome: "租金收入",
        wuyepay: "物业费",
        wuyeRevenue: "物业增值税6%",
        wuyeIncome: "物业费收入",
        promotionSum: "推广费",
        promotionRevenue: "推广增值税6%",
        promotionIncome: "推广费收入",
        electricPay: "购电费",
        waterPay: "水费",
        total: "应缴合计",
      },
      roleId: "",
      paymentBillVos: [],
      shopList: [],
      pageSum: 0,
      zujinsum: 0,
      wuyesum: 0,
      tuiguangsum: 0,
      qitasum: 0,
    };
  },
  created() {
    this.roleId = localStorage.roleId;
    this.setMonth();

    this.getShopList();
    this.getAll();
  },
  methods: {
    getShopList() {
      let selectForm = {
        currentPage: 1,
        pageSize: 1000,
      };
      this.$http.post("/api/bdShop/queryShop", selectForm).then((res) => {
        this.shopList = res.data.data.items;
      });
    },
    query() {
      this.form.currentPage = 1;
      this.getAll();
    },
    handleSelectionChange(val) {
      this.paymentBillVos = val;
      console.log(val);
    },
    addShopPay() {
      let data = {
        type: "其他",
        timeQuantum: this.timeOther,
        time: this.rowTome,
        amount: "",
        editNo: "1",
        editIs: "1",
      };
      this.bdShopPayList.push(data);
      this.isAdd = false;
    },
    setMonth() {
      let year = new Date().getFullYear();
      let mon = new Date().getMonth() + 1;
      mon = mon;
      if (mon <= 0) {
        year = year - 1;
        mon = mon + 12;
      }
      if (mon < 10) {
        mon = "0" + mon;
      }
      let queryMonth = year + "-" + mon;
      this.queryDate = [queryMonth, queryMonth];
    },
    editShopPay(row, index) {
      this.bdShopPayList[index].editIs = "1";
      this.comKey = !this.comKey;
    },
    saveShopPay(row, index) {
      if (row.amount === "") {
        this.$message.error("请输入金额");
        return;
      }
      if (row.id) {
        let data = {
          list: [
            {
              id: row.id,
              money: row.amount,
              type: row.type,
              time: row.time,
              remark: row.remark,
            },
          ],
          shopNum: this.obj.shopNum,
          time: row.time,
        };
        this.$http.post("/api/shopPay/update", data).then((res) => {
          if (res.data.code == 0) {
            this.$message.success(res.data.data);
            this.bdShopPayList[index].editIs = "0";
            this.comKey = !this.comKey;
            this.getAll();
            this.calculateDifference(this.obj.shopNum);

          } else {
            this.$message.error(res.data.data);
          }
        });
      } else {
        let data = {
          shopNum: this.obj.shopNum,
          time: row.time,
          type: row.type,
          money: row.amount,
          shopPayId: this.obj.id,
        };
        this.$http.post("/api/shopPay/insertFundsTpype", data).then((res) => {
          if (res.data.code == 0) {
            this.$message.success("保存成功");
            this.bdShopPayList[index].editIs = "0";
            this.getAll();
            this.calculateDifference(this.obj.shopNum);

          } else {
            this.$message.error("保存失败");
          }
        });
      }
    },
    aaa() {
      // if (1 == 1) {
      //     this.$message.error("水电费为空，无法打印！")
      //     return false;
      // }
      this.isDyxs = false;
      this.isAdd = false;
      setTimeout((r) => {
        this.$print(this.$refs.print);
      }, 1000);
    },
    dcAll() {
      const loading = this.$loading({
        lock: true,
        text: "努力加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$http
        .post(
          "/api/shopPay/downloadContract",
          {
            list: this.paymentBillVos,
          },
          { timeout: 60000 }
        )
        .then((res) => {
          if (res.data.code == 0) {
            location.href = res.data.data;
            // window.open(res.data.data)
          } else {
            this.$message.error(res.data.message);
          }
          loading.close();
        });
    },
    checkChange(val) {
      //筛选列复选框被改变
      console.log(val);
      // val.forEach(val=>{
      // 	if(val=='')
      // })
      var newObj = {};
      for (var key in this.oldTitleObj) {
        if (val.indexOf(this.oldTitleObj[key]) != -1) {
          newObj[key] = this.oldTitleObj[key];
        }
      }
      this.titleObj = newObj;
      if (val.length == 1) {
        //只有一列时,复选框禁止勾选
        this.oneRow = val[0];
        this.$message.warning("表格内容至少显示一列");
        return;
      }
      this.oneRow = "";
    },

    handleClose() {
      this.show = false;
      this.isDyxs = true;
    },
    downFil(item) {
      downloadFile(item);
    },
    changeRow(obj) {
      this.id = obj.id;
      this.status = obj.status;
      this.isChange = true;
    },
    isOk() {
      this.$http
        .post("/api/shopPay/updateShopPay", {
          id: this.id,
          status: this.status,
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.$message.success(res.data.message);
            this.isChange = false;
            this.getAll();
          }
          console.log(res);
        });
    },
    lookRow(obj) {
      this.obj = obj;
      this.sum = 0;
      this.bdShopPayList = [];
      this.$http.get(`/api/reconciliation/getPaymentBills?id=${obj.id}`).then((res) => {
        if (res.data.code == 0) {
          let isAdd = true;

          this.bdShopPayList = res.data.data;

          this.bdShopPayList.forEach((val) => {
            val.editIs = "0";
            val.editNo = "1";
            this.sum = val.amount + this.sum;
            if (val.type == "其他") {
              isAdd = false;
            } else {
              this.timeOther = val.timeQuantum;
              this.rowTome = val.time;
            }
          });
          // if (this.obj.balance < 0) {
          //   let data = {
          //     type: "历史欠费",
          //     timeQuantum: "",
          //     amount: this.obj.balance * -1,
          //     editNo: "-1",
          //     editIs: "0",
          //   };
          //   this.bdShopPayList.push(data);
          // }
          this.isAdd = isAdd;
          this.show = true;
        } else {
          this.$message.error("查询失败！");
        }
      });
    },
    handleCurrentChange(val) {
      this.form.currentPage = val;
      this.getAll();
    },
    handleSizeChange(val) {
      this.form.pageSize = val;
      this.getAll();
    },
    dc() {
      if (this.queryDate && this.queryDate.length == 2) {
        this.form.startDate = this.queryDate[0];
        this.form.endDate = this.queryDate[1];
      } else {
        this.form.startDate = "";
        this.form.endDate = "";
      }
      publicExport("/api/shopPay/exportShopPay", this.form, "费用收缴");
    },
    getAll() {
      //获取表格数据
      if (this.queryDate && this.queryDate.length == 2) {
        this.form.startDate = this.queryDate[0];
        this.form.endDate = this.queryDate[1];
      } else {
        this.form.startDate = "";
        this.form.endDate = "";
      }
      this.loading = true;
      this.$http.post("/api/shopPay/queryShopPay", this.form).then((res) => {
        this.loading = false;
        if (res.data.code == 0) {
          this.count = res.data.data.totalNum;
          this.data = res.data.data.items;
          this.pageSum = res.data.data.sum;
          this.zujinsum = res.data.data.zujinsum;
          this.wuyesum = res.data.data.wuyesum;
          this.tuiguangsum = res.data.data.tuiguangsum;
          this.qitasum = res.data.data.qitasum;
        }
      });
    },
  },
};
</script>

<style scoped="scoped">
.box {
  font-size: 16px;
  width: 70%;
}

.box > div {
  margin-bottom: 10px;
}
</style>
